import(/* webpackMode: "eager" */ "/app/app/[locale]/products/citadel/page.tsx");
